module.exports = __webpack_public_path__ + "img/3-1.c3cbd91e.png";